export const HOSTING_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  SUSPENDED: 'suspended',
  TERMINATED: 'terminated',
  CANCELLED: 'cancelled',
  FRAUD: 'fraud',
  BUILDING: 'building',
  ACTIVATION_PENDING: 'activationPending',
};

export const DOMAIN_DISABLE_MANAGE = {
  EXPIRED: 'expired',
  PENDING: 'pending',
  REGISTER_ERROR: 'registerError',
  PENDING_TRANSFER: 'pendingTransfer',
  CANCELLED: 'cancelled',
  TERMINATED: 'terminated',
  FRAUD: 'fraud',
};

export const HOSTING_DISABLE_MANAGE = {
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  TERMINATED: 'terminated',
  FRAUD: 'fraud',
};
